<template>
  <Modal
    :show="show.unlinkHrisProfileConfirm"
    action-text="Remove link"
    @close="close"
    @action="confirm"
  >
    <template #title>
      {{ draftProfile ? 'Remove draft profile link' : `Remove ${authData.hrisName} profile link` }}
    </template>

    <template #content>
      <template v-if="draftProfile">
        This will remove the link from draft profile
        <strong>{{ draftProfile.title }}</strong>
        to this {{ authData.hrisName }} profile.
        Are you sure you want to continue?
      </template>
      <template v-else>
        This will remove the link to {{ authData.hrisName }} profile
        <strong>{{ hrisReference?.title }}</strong>
        <template v-if="hrisReference?.hris_job_code">
          ({{ hrisReference.hris_job_code }})
        </template>.
        Are you sure you want to continue?
      </template>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useAppAuthData } from '@/stores/app/authData';
import Modal from '@/components/shared/Modal.vue';

const { authData } = storeToRefs(useAppAuthData());

const { show, modalParams } = storeToRefs(useModals());
const { setModal } = useModals();

const { jobProfile } = storeToRefs(useCurrentJobProfile());
const hrisReference = computed(() => jobProfile.value?.hris_reference ?? null);
const draftProfile = computed(() => modalParams.value.unlinkHrisProfileConfirm?.draftProfile ?? null);

const close = () => setModal({ field: 'unlinkHrisProfileConfirm', value: false });

const confirm = async () => {
  if (draftProfile.value) {
    await useCurrentJobProfile().unlinkDraftProfile(draftProfile.value.ulid);
  } else {
    await useCurrentJobProfile().linkHrisProfile(null);
  }
  close();
};
</script>
